import { render, staticRenderFns } from "./DynamicDictionariesSettingsList.vue?vue&type=template&id=76a491d3&"
import script from "./DynamicDictionariesSettingsList.vue?vue&type=script&lang=js&"
export * from "./DynamicDictionariesSettingsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports